import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";

@Component({
	selector: 'unos-izmjena-flice',
	templateUrl: './unos-izmjena-flice.component.html',
	styleUrls: ['./unos-izmjena-flice.component.css']
})
export class UnosIzmjenaFizLice implements OnInit {
	@Input() id;
	@Input() nazivPLice;

	@Output() onInsertFLice = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	loading = false;
	msg : any;
	daneStavke : any = [{ 'id': '0', 'naziv': 'Ne', jeOdabran: false }, { 'id': '1', 'naziv': 'Da', jeOdabran: false }];
	flice : any = {id : null, ime : null, prezime : null, adresa : null};

	err_ime = false;
	err_ime_poruka = '';
	err_prezime = false;
	err_prezime_poruka = '';

	ngOnInit() {
		this.ucitaj();
	}

	server_data : any = null;

	ucitaj() {
		if (!this.id)
			return;

		this.loading = true;
		this.http.get('vlasnici/detaljno', { params: { id: this.id } })
			.subscribe(data => {
				this.loading = false;
				this.flice = data;

				setTimeout(() => {
					M.updateTextFields();
				}, 300);
				
				//this.ucitajSkole();
			}
			, error => {
				this.loading = false;
			});
	}

	toastTimeout = 5000;

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	savedata(){
		if (!this.flice.ime) {
			this.err_ime = true;
			this.err_ime_poruka = 'Morate definisati polje Ime.';
			M.toast({html: this.err_ime_poruka, displayLength : this.toastTimeout});
			return;
		}

		if (!this.flice.prezime) {
			this.err_prezime = true;
			this.err_prezime_poruka = 'Morate definisati polje Prezime.';
			M.toast({html: this.err_prezime_poruka, displayLength : this.toastTimeout});
			return;
		}

		let url = 'vlasnici/fizicko/dodaj';
		if (this.id){
			url = 'vlasnici/fizicko/izmijeni';
		}

		this.loading = true;
		
		setTimeout(() => {				
		
			this.http.post(url, this.flice)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;

					if (this.msg.id == 1) {
						if (!this.id) {
							this.flice.id = this.msg.newId;
						}
						if (this.onInsertFLice)
							this.onInsertFLice.emit(this.flice);
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : this.toastTimeout});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}

}
